// extracted by mini-css-extract-plugin
export default {"wrapper":"PaymentStatusPublic_wrapper__IRszR","banner":"PaymentStatusPublic_banner__yOpUR"};